import { KendraConst, SearchInterface } from "@amzn/ask-legal-domain";
import { Multiselect, MultiselectProps } from "@amzn/awsui-components-react";
import * as React from "react";
import { UIModel } from "../../../model/ui-model";
import { getStringFilterValues, replaceStringFilters } from "./search-filter-utils-v2";

const CONTENT_TYPE = KendraConst.ContainerIngestionKendraAttributes.Custom.ContentType;
const TYPE_OPTIONS: MultiselectProps.Option[] = ["Page", "Document", "Link"].map(t => ({ label: t, value: t }));

export const FileTypeFilterV2 = (props: {
    queryInputState: UIModel.State<SearchInterface.SearchQueryInput>;
    disabled?: boolean;
}) => {
    const selectedValues = getStringFilterValues(props.queryInputState.value, CONTENT_TYPE);
    const selectedOptions = TYPE_OPTIONS.filter(o => selectedValues.includes(o.value!));

    return (
        <Multiselect
            inlineLabelText="File type"
            placeholder="All"
            inlineTokens
            selectedOptions={selectedOptions}
            options={TYPE_OPTIONS}
            disabled={props.disabled}
            onChange={({ detail }) => props.queryInputState.setValue(replaceStringFilters(
                props.queryInputState.value,
                CONTENT_TYPE,
                detail.selectedOptions.map(o => o.value).filter((v): v is string => !!v)
            ))}
        />
    );
};
